import {combineReducers} from 'redux';
import ajaxCallInProgress from "./ajaxStatusReducer";
import dictionary from "./dictionaryReducer";
import chapters from "./chaptersReducer";
import transition from './transitionReducer';
import chapterVisibility from './chapterVisibilityReducer';
import options from './optionsReducer';
import gameVisibility from './gameVisibilityReducer';


const rootReducers = combineReducers({
    ajaxCallInProgress,
    dictionary,
    options,
    chapters,
    transition,
    chapterVisibility,
    gameVisibility
});

export default rootReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js